import React from 'react';

const discounts = [
  { id: 1, store: 'Bol.com', discount: '10% korting', code: 'STUDENT10', desc: 'Op alle boeken en studie materialen' },
  { id: 2, store: 'Albert Heijn', discount: '5% korting', code: 'AHSTUDENT', desc: 'Op je wekelijkse boodschappen' },
  { id: 3, store: 'Spotify Premium', discount: '50% korting', code: 'SPOTIFY50', desc: 'Studentenabonnement voor €5,99/maand' },
  { id: 4, store: 'NS', discount: '40% korting', code: 'NSSTUDENT', desc: 'Met studenten OV-kaart korting' },
  { id: 5, store: 'Coolblue', discount: '8% korting', code: 'COOLSTUDENT', desc: 'Op laptops en elektronica' },
  { id: 6, store: 'Netflix', discount: 'Gratis 1 maand', code: 'NETFLIXFREE', desc: 'Probeer Netflix gratis voor studenten' },
];

export default function DiscountsPage() {
  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-5xl font-bold text-center mb-12 text-gray-800">Studentenkortingen</h1>
      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {discounts.map(d => (
          <div key={d.id} className="bg-white rounded-2xl shadow-lg p-6 border-l-4 border-blue-600">
            <div className="text-sm text-gray-500 mb-2">{d.store}</div>
            <div className="text-2xl font-bold text-blue-600 mb-2">{d.discount}</div>
            <div className="bg-gray-100 px-4 py-2 rounded-lg font-mono text-center mb-4">{d.code}</div>
            <p className="text-gray-600 text-sm">{d.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
